import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { FEEDBACK, FEEDBACK_INBOX, FEEDBACK_MINE } from '@/endpoints'
import axios from '@/lib/axios'

export const INBOX_KEY = ['feedback', 'inbox']
export const MINE_KEY = ['feedback', 'mine']

export function useSubmitFeedback() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (data) => axios.post(FEEDBACK, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: MINE_KEY })
            queryClient.invalidateQueries({ queryKey: INBOX_KEY })
        }
    })
}

export function useMyFeedback() {
    return useQuery({
        queryKey: MINE_KEY,
        queryFn: async () => (await axios.get(FEEDBACK_MINE)).data
    })
}

export function useFeedbackInbox(status) {
    return useQuery({
        queryKey: [...INBOX_KEY, 'list', status],
        queryFn: async () => {
            const response = await axios.get(FEEDBACK_INBOX, {
                params: status ? { status } : {}
            })
            return response.data
        }
    })
}

export function useFeedbackByPage({ enabled = true } = {}) {
    return useQuery({
        queryKey: [...INBOX_KEY, 'byPage'],
        queryFn: async () =>
            (await axios.get(`${FEEDBACK_INBOX}by-page/`)).data,
        enabled
    })
}

export function useResolveFeedback() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ id, resolved }) =>
            axios.post(`${FEEDBACK_INBOX}${id}/resolve/`, { resolved }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: INBOX_KEY })
    })
}

export function useReplyToFeedback() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ id, reply }) =>
            axios.post(`${FEEDBACK_INBOX}${id}/reply/`, { reply }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: INBOX_KEY })
    })
}
